<template>
  <div class="d-flex justify-content-center align-items-center body-wrapper" :class="{ 'dark-theme': isDarkMode }">
    <confirmModal  ref="confirmModalRef" id="confirmModal" :isCancel="isCancel" :modalTitle="modalTitle"
      :modalText="modalText" @confirmAction="confirmAction" :isDark="isDarkMode" />
    <otpModal ref="otpModalRef" :msisdn="subscriber.msisdn" @resendOtp="confirmAction" @confirmOtp="confirmOtp" :isDark="isDarkMode" />
    <alertModal ref="alertModalRef" id="alertModal" :modelType="modelType" :modalTitle="alertModelTitle"
      :modalText="alertModelText" :modalButtonText="modalButtonText" :isDark="isDarkMode" />

    <div class="app-screen">
      <header class="app-header">
      </header>

      <main class="main-content">
        <ul class="details-list">
          <li class="details-list-item">
            <span class="item-label">{{ $t('profile.username') }}</span>
            <input type="text" class="form-input" :value="subscriber?.details?.name"
              :placeholder="$t('profile.usernamePlaceholder')" :aria-label="$t('profile.username')" readonly>
          </li>
          <li class="details-list-item">
            <span class="item-label">{{ $t('profile.phoneNumber') }}</span>
            <input type="tel" id="phone-number-input" :value="subscriber.msisdn" class="form-input"
              :placeholder="$t('profile.phoneNumberPlaceholder')" :aria-label="$t('profile.phoneNumber')" readonly>
          </li>
          <li class="details-list-item">
            <span class="item-label">{{ $t('profile.package') }}</span>
            <input type="text" class="form-input" :value="subscriber?.details?.subscription_name"
              :placeholder="$t('profile.packagePlaceholder')" :aria-label="$t('profile.package')">
          </li>
          <li class="details-list-item">
            <span class="item-label">{{ $t('profile.validity') }}</span>
            <input type="text" class="form-input" :value="subscriber?.details?.expiration_date"
              :placeholder="$t('profile.validityPlaceholder')" :aria-label="$t('profile.validity')">
          </li>
          <li class="details-list-item">
            <span class="item-label">{{ $t('profile.subscriptionStatus') }}</span>
            <div class="item-value">
              <span :class="['badge', statusClass]">{{ subscriptionStatusText }}</span>
            </div>
          </li>
        </ul>
      </main>

      <footer class="app-footer" v-if="!isSaudi">
        <button class="btn btn-custom-primary" @click="openModal">
          {{ actionButtonText }}
        </button>
      </footer>

    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useProfileStore } from '@/store/profile';
import confirmModal from "@components/alerts/confirmModal.vue"; 
import otpModal from "@components/alerts/otpModal.vue"; 
import alertModal from "@components/alerts/alertModal.vue"; 

const { t } = useI18n();
const profile = useProfileStore();

const route = useRoute();
 
const subscriber = computed(() => profile.subscriber); 
const errors = computed(() => profile.errors);
 // To store references for focus management
 
const alertModelTitle = ref('');
const alertModelText = ref('');

const modalButtonText = ref('');
const modelType = ref('');
const confirmModalRef = ref(null) 
const otpModalRef = ref(null)  
const alertModalRef = ref(null)

const isDarkMode = ref(route.query.is_dark === 'true');
// 1. تحديد ما إذا كان الاشتراك منتهي الصلاحية أم لا
const isCancel = computed(() => {
  // هذا مجرد مثال، يجب تعديله بناءً على البيانات الحقيقية
  // سنفترض أن الحالة تأتي من API
  return subscriber.value?.details?.status === 'cancel';
});

// 2. تحديد نص حالة الاشتراك
const subscriptionStatusText = computed(() => {
    let status = subscriber.value?.details?.status || 'active'; // 'active' or 'cancel'
    // تحويل 'cancel' إلى 'expired' ليتوافق مع الترجمة والمعنى المطلوب
    if (status === 'cancel') {
      status = 'expired';
    }
    return t(status);
});

// 3. تحديد نص زر الإجراء بناءً على الحالة
const actionButtonText = computed(() => {
    return isCancel.value 
           ? t('profile.renewSubscription')
           : t('profile.cancelSubscription');
});

// 4. تحديد فئة (Class) حالة الاشتراك للتلوين (للتصميم)
const statusClass = computed(() => {
    return isCancel.value ? 'badge-expired' : 'badge-active';
});

// 5. التحقق مما إذا كان المستخدم سعودي (عن طريق كود الدولة 966) لإخفاء الزر
const isSaudi = computed(() => {
  return subscriber.value?.msisdn && String(subscriber.value.msisdn).startsWith('966');
});

// Modal dynamic content
const modalTitle = computed(() => {
  return isCancel.value ? t('profile.modal.renewTitle') : t('profile.modal.cancelTitle');
});

const modalText = computed(() => {
  return isCancel.value ? t('profile.modal.renewText') : t('profile.modal.cancelText');
});
 
const openModal=()=> {
   confirmModalRef.value.showModal();
}
 
const confirmAction= async ()=> {
   isCancel.value?await profile.requestReactivate():await profile.requestCancellation();
   confirmModalRef.value.closeModal();
   otpModalRef.value.showModal();
}

const confirmOtp=async (event)=> {
  let data={otp: event};
  let res=isCancel.value?await profile.confirmReactivate(data):await profile.confirmCancellation(data);
  
  alertModelText.value = isCancel.value ?   'profile.modal.successRenewText':'profile.modal.successCancelText';
  alertModelTitle.value = isCancel.value ? 'profile.modal.successTitle' : 'profile.modal.successTitle';
  modalButtonText.value = 'profile.modal.continue';
  if(res){
    modelType.value = 'success';
    await profile.getSubscriberDetails();
  }else{
    alertModelTitle.value = 'profile.modal.errorTitle';
    alertModelText.value = 'profile.modal.errorText';
    modelType.value = 'error';
  }
  otpModalRef.value.closeModal();
  alertModalRef.value.showModal();
}

 
 

onMounted(async () => {
   let access = route.params.access;
   localStorage.setItem('token', access);
   await profile.getSubscriberDetails();
});

 
</script>

<style  >
/* Dark Theme Styles will be moved to the end */
/* RTL Styles */
[dir="rtl"] .back-button {
  transform: scaleX(-1);
  left: auto;
  /* The right position will be handled by the general styles */
  right: 20px;
}

[dir="rtl"] .item-label, [dir="rtl"] .form-input {
  text-align: right;
}

[dir="rtl"] .item-value {
  text-align: right;
}

[dir="rtl"] .otp-input-fields {
  flex-direction: row-reverse;
}

/* General Styles (Copied for consistency) */
.body-wrapper {
    background-color: #f0f0f0; 
    font-family: 'Urbanist', sans-serif;
    min-height: 100vh;
}

.app-screen {
    max-width: 400px; /* Matched with login.html */
    height: 100vh; /* جعل ارتفاع الصفحة يملأ الشاشة بالكامل */
    background-color: #ffffff;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    margin: auto;
    display: flex;
    flex-direction: column;
    padding: 0 20px 20px 20px; /* Matched with login.html */
}

.app-header {
    padding-top: 20px; 
    margin-bottom: 10px;
    display: flex; 
    justify-content: center; /* Center the content (title) */
    align-items: center;
    position: relative; /* Needed for absolute positioning of the back button */
}

.back-button {
  /* This is now the primary style for the back button */
  position: absolute;
  left: 20px; /* Default position for LTR */
  font-size: 30px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  background-color: transparent;
  background-color: #f5f5f5;
  border-radius: 50%;
  color: #333;
  text-decoration: none;
  transition: color 0.3s, background-color 0.3s;
  transition: background-color 0.3s;
}

.back-button:hover {
  color: #ff5a36;
  background-color: #f5f5f5; /* إضافة خلفية ناعمة عند المرور */
  background-color: #e9e9e9;
}

.back-button svg {
  width: 24px;
  height: 24px;
}

.header-title {
    font-size: 16px; /* Made title even smaller */
}

/* --- Subscription Details List Styling --- */
.details-list {
    list-style: none;
    padding: 16px; /* المطابقة مع الفيجما */
    margin: 0 0 20px 0;
    border: 1px solid #e0e0e0;
    border-radius: 24px; /* المطابقة مع الفيجما */
    background-color: #fff;
}
.details-list-item {
    padding: 12px 0;
    border-bottom: 1px solid #f0f0f0;
}
.details-list-item:first-child {
    padding-top: 0;
}
.details-list-item:last-child {
    border-bottom: none;
    padding-bottom: 0;
}
.item-label {
    display: block;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #8D8D8D;
    line-height: 20px;
    letter-spacing: -0.36px;
    margin-bottom: 0;
    text-align: left;
}

.badge {
  display: inline-block;
  padding: 0.5em 1em;
  font-size: 0.85em;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 50rem; /* Fully rounded corners */
}

.badge-active {
  color: #1E8E3E; /* Bright green text */
  background-color: #E6F4EA; /* Light green background */
  border: 1px solid #A8DAB5;
}

.badge-expired {
  color: #D93025; /* Calm red text */
  background-color: #FCE8E6; /* Light red background */
  border: 1px solid #F6B6B1;
}


.item-value {
    font-size: 16px;
    color: #212529; /* Bootstrap's default text color */
}

/* --- New Input Field Styling --- */
.form-input {
    width: 100%;
    border: none;
    padding: 0;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 600;
    color: #191A26; /* اللون الصحيح من الفيجما */
    line-height: 20px;
    letter-spacing: 0px;
    background-color: transparent;
    text-align: left;
}
.form-input:focus {
    outline: none;
}
.form-input::placeholder {
    color: #adb5bd; /* Darker placeholder text */
}

/* --- Sticky Footer Styling --- */
.app-footer {
  padding: 1rem 0;
  background-color: #fff;
  /* The following properties make the footer sticky */
  position: sticky;
  bottom: 0;
  box-shadow: none !important;
  border-top: none !important;
  display: flex; /* إضافة flexbox */
  justify-content: center; /* توسيط المحتوى (الزر) */
}

@media (max-width: 768px) {
  .app-footer {
    position: fixed; /* This makes it stick to the visual viewport */
    left: 0;
    right: 0;
    padding: 0 20px 20px; /* إضافة حشوة سفلية لرفع الزر */
  }
}
.main-content {
    flex-grow: 1; /* Allow main content to take up available space */
    overflow-y: auto; /* Allow content to scroll if it overflows */
}
/* --- General CTA Button Styling --- */
.btn-custom-primary {
    background-color: #FF5A36 !important; 
    color: white !important;
    border: none;
    border-radius: 30px; /* More rounded edges */
    font-weight: 700;
    padding: 15px 0;
    width: 94%; /* 🚀 تعديل: التحكم في عرض الزر لترك فراغ جانبي */
    margin: 0 auto; /* توسيط الزر */
    transition: background-color 0.3s;
}

.btn-custom-primary:disabled {
    background-color: #ff9984 !important; 
    cursor: not-allowed;
}


/* --- Media Queries for smaller screens --- */
@media (max-width: 768px) {
    .body-wrapper {
        /* Remove centering on mobile to allow full width */
        background-color: #ffffff; 
    }
    .body-wrapper.dark-theme {
        background-color: #121212; /* تصحيح الخلفية في وضع الدارك مود للجوال */
    }
    .app-screen {
        width: 100%; 
        max-width: 100%; 
        height: 100vh; 
        box-shadow: none; 
        border-radius: 0; 
        padding-bottom: 100px; 
    }
    .dark-theme .app-screen {
        background-color: #1E1E1E; /* تصحيح لون الشاشة في وضع الدارك مود للجوال */
    }
}

/* --- Modal Styles --- */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
  padding: 20px;
}

.modal-container {
  background-color: #fff;
  border-radius: 15px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
  width: 100%;
  max-width: 350px;
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: 20px;
}

.modal-icon-wrapper {
  margin-bottom: 15px;
}

.modal-icon {
  width: 90px; /* تم تكبير الدائرة */
  height: 90px; /* تم تكبير الدائرة */
  border-radius: 50%;
  background-color: #FF5A36; /* Bright Orange */
  color: white;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 60px; /* تم تكبير حجم الـ X */
  font-weight: 300; /* تم تنحيف الـ X */
  line-height: 1;
}

.cancel-icon {
  font-size: 60px; /* تم تكبير حجم الـ X */
  font-weight: 300; /* تم تنحيف الـ X */
  color: white; /* التأكيد على أن لون الأيقونة أبيض */
}

.renew-icon-svg {
  width: 50px;
  height: 50px;
  fill: white; /* تحديد لون الأيقونة إلى الأبيض */
}

.modal-body {
  margin-bottom: 20px;
}

.modal-title {
  margin: 0 0 10px 0;
  font-size: 1.25rem;
  font-weight: 700;
  color: #212529;
}

.modal-text {
  margin: 0;
  color: #6c757d;
  font-size: 1rem;
}

.modal-footer {
  display: flex;
  flex-direction: row;
  gap: 10px;
  width: 100%;
}

.btn-modal {
  flex: 1; /* تعديل: لجعل الأزرار تتشارك المساحة بالتساوي */
  border-radius: 30px;
  padding: 12px 0;
  font-weight: 700;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s;
}

.btn-danger {
  background-color: #FF5A36;
  color: white;
}

.btn-danger:hover {
  background-color: #e04a2a; /* Darker orange */
  color: white !important; /* 🚀 تعديل: التأكيد على بقاء النص أبيض */
}

.btn-primary {
  background-color: #007bff;
  color: white;
}

.btn-primary:hover {
  background-color: #0069d9; /* Darker blue */
  color: white !important; /* 🚀 تعديل: التأكيد على بقاء النص أبيض */
}

.btn-secondary {
  background-color: #f0f0f0;
  color: #333;
}
.btn-secondary:hover {
  /* Change background to a darker grey to contrast with white text */
  background-color: #6c757d; 
  color: white !important; /* 🚀 تعديل: التأكيد على بقاء النص أبيض */
}

/* --- Success Modal Icon --- */
.success-icon {
  font-size: 50px; /* Checkmark size */
  font-weight: bold;
}

.error-icon {
  /* نستخدم نفس نمط modal-icon ولكن نضبط حجم رمز التعجب */
  font-size: 55px; 
  font-weight: bold;
}

.error-icon-svg {
  width: 55px;
  height: 55px;
  fill: white;
}


/* --- OTP Modal Styles --- */
.otp-modal {
  padding: 30px;
}

.otp-input-fields {
  display: flex;
  justify-content: center;
  gap: 15px;
  margin: 30px 0;
}

.otp-input {
  width: 50px;
  height: 60px;
  border: none;
  border-bottom: 2px solid #ccc;
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  color: #333;
  background-color: transparent;
  transition: border-color 0.3s;
}

.otp-input:focus {
  outline: none;
  border-color: #FF5A36;
}

.resend-link {
  display: block;
  margin-bottom: 30px;
  color: #FF5A36;
  text-decoration: none;
  font-weight: 600;
  font-size: 1rem;
}

.resend-link:hover {
  text-decoration: underline;
}

.btn-confirm {
  width: 100%;
  background-color: #FF5A36;
  color: white;
  border: none;
  border-radius: 30px;
  padding: 15px 0;
  font-weight: 700;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s;
}
.btn-confirm:hover {
  background-color: #e04a2a;
}

.hidden {
  display: none;
}
/* ----------------------------------
 * Dark Theme Styles (Moved to bottom for priority)
 * ---------------------------------- */
.body-wrapper.dark-theme {
    background-color: #121212;
}
.dark-theme .app-screen {
    background-color: #1E1E1E;
}
.dark-theme .details-list {
    border-color: #333;
    background-color: #1E1E1E;
}
.dark-theme .details-list-item {
    border-color: #333;
}
.dark-theme .item-label {
    color: #a0a0a0;
}
.dark-theme .item-value {
    color: #ffffff;
}
.dark-theme .form-input {
    color: #ffffff;
}
.dark-theme .form-input::placeholder {
    color: #777;
}
.dark-theme .app-footer {
    background-color: #1E1E1E !important;
}
.dark-theme .back-button {
    background-color: #333;
    color: #ffffff;
}
.dark-theme .back-button:hover {
    background-color: #444;
}
.dark-theme .modal-container {
    background-color: #1E1E1E;
    color: #ffffff;
}
.dark-theme .modal-title {
    color: #ffffff;
}
.dark-theme .modal-text {
    color: #a0a0a0;
}
.dark-theme .btn-secondary {
    background-color: #333;
    color: #ffffff;
}
.dark-theme .btn-secondary:hover {
    background-color: #444;
}
.dark-theme .badge-active {
    background-color: rgba(30, 142, 62, 0.2);
    border-color: #1E8E3E;
    color: #81c995;
}
.dark-theme .badge-expired {
    background-color: rgba(217, 48, 37, 0.2);
    border-color: #D93025;
    color: #f28b82;
}
.dark-theme .otp-input {
    color: #ffffff;
    border-bottom-color: #444;
}

.dark-theme .modal-icon {
    background-color: #FD451C; /* توحيد لون الأيقونة في المودال */
}

.dark-theme .main-content::-webkit-scrollbar-thumb {
  background-color: #424242;
}
</style>